module.exports = __webpack_public_path__ + "img/IMG-4871.afe442b2.jpg";